export default __webpack_public_path__ + "static/media/linkedin.880bcce7.svg";